import classNames from "classnames";
import React, { useMemo } from "react";
import { validatePassword, Validations } from "@/libs/utils";

import "./styles.scss";

interface PasswordStrengthProps {
  password: string;
  style?: React.CSSProperties;
  isTouched?: boolean;
}

const rules: { label: string; key: keyof Validations }[] = [
  { label: "8 characters minimum", key: "length" },
  { label: "One uppercase letter", key: "uppercase" },
  { label: "One lowercase letter", key: "lowercase" },
  { label: "One number", key: "number" },
  { label: "One special character", key: "special" },
];

const PasswordStrength: React.FC<PasswordStrengthProps> = ({
  password = "",
  style,
  isTouched = false,
}) => {
  const { validations } = useMemo(() => validatePassword(password), [password]);

  return (
    <div className="password-strength" style={style}>
      <div className="password-strength__title">Password Strength</div>
      <div className="password-strength__items">
        {rules.map(rule => (
          <div
            key={rule.key}
            className={classNames("password-strength__items__item")}
          >
            <span
              className={classNames("k-font-icon", {
                "k-i-error": isTouched && !validations[rule.key],
                "k-i-success": !(isTouched && !validations[rule.key]),
                invalid: isTouched && !validations[rule.key],
                valid: validations[rule.key],
              })}
            />

            <div
              className={classNames({
                "text-invalid": isTouched && !validations[rule.key],
                "text-valid": validations[rule.key],
              })}
            >
              {rule.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default React.memo(PasswordStrength);
